import Mutations from '../../odata/mutations';

export default { ...new Mutations('shop'), ...new Mutations('shops') };
